/**
 * BOTTOM GENERAL INITS
 * livecast
 */

import { Livecast } from "./livecast";


export class LivecastInits {
    constructor() {
        this.initMap();
    }

    initMap() {
        if ($('.livecast-list').length) {
            new Livecast();
        }
    }
}
